// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1ig8k","label":"LabeledBox_label__3cxhJ"};